// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appinfosfulldiv
{
    width:calc(100% - 40px);
    height: 100%;
    font-family: Arial, Helvetica, sans-serif;
    font-size: small;
    margin-left: 20px;
    margin-right: 20px;
    overflow: hidden;

}

.appinfostitlediv
{
    width:100%;
    height: 20px;
}

.appinfoscontentdiv
{
    width: 100%;
    max-height: calc(100% - 20px);
    overflow: hidden; /* Hides the scrollbar */
    overflow-y: auto; /* Enables vertical scrolling with the mouse wheel */
    -ms-overflow-style: none; /* Hides scrollbar in Internet Explorer */
    scrollbar-width: none; /* Hides scrollbar in Firefox */
}

  
.appinfoscontentdiv::-webkit-scrollbar {
    display: none; /* Hides scrollbar in Chrome, Edge, and Safari */
  }
  

.appinfostitle
{
    text-align: center;
    background-color: #303030;
    border-color: #808080;
    border-radius: 5px;
    border-width: 1px;
    border-style: solid;
    margin-top: 10px;
    margin-bottom: 10px;
  

}

.appinfocontent
{
    text-align: left;
    padding-left: 20px;
    color: var(--default-icon-color);
}

.appinfocontentvalue
{
    color:white;
    text-align: right;
    
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appinfos/appinfos.css"],"names":[],"mappings":"AAAA;;IAEI,uBAAuB;IACvB,YAAY;IACZ,yCAAyC;IACzC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;;IAEI,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,6BAA6B;IAC7B,gBAAgB,EAAE,wBAAwB;IAC1C,gBAAgB,EAAE,oDAAoD;IACtE,wBAAwB,EAAE,yCAAyC;IACnE,qBAAqB,EAAE,+BAA+B;AAC1D;;;AAGA;IACI,aAAa,EAAE,gDAAgD;EACjE;;;AAGF;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;;;AAGvB;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;;IAEI,WAAW;IACX,iBAAiB;;AAErB","sourcesContent":[".appinfosfulldiv\n{\n    width:calc(100% - 40px);\n    height: 100%;\n    font-family: Arial, Helvetica, sans-serif;\n    font-size: small;\n    margin-left: 20px;\n    margin-right: 20px;\n    overflow: hidden;\n\n}\n\n.appinfostitlediv\n{\n    width:100%;\n    height: 20px;\n}\n\n.appinfoscontentdiv\n{\n    width: 100%;\n    max-height: calc(100% - 20px);\n    overflow: hidden; /* Hides the scrollbar */\n    overflow-y: auto; /* Enables vertical scrolling with the mouse wheel */\n    -ms-overflow-style: none; /* Hides scrollbar in Internet Explorer */\n    scrollbar-width: none; /* Hides scrollbar in Firefox */\n}\n\n  \n.appinfoscontentdiv::-webkit-scrollbar {\n    display: none; /* Hides scrollbar in Chrome, Edge, and Safari */\n  }\n  \n\n.appinfostitle\n{\n    text-align: center;\n    background-color: #303030;\n    border-color: #808080;\n    border-radius: 5px;\n    border-width: 1px;\n    border-style: solid;\n    margin-top: 10px;\n    margin-bottom: 10px;\n  \n\n}\n\n.appinfocontent\n{\n    text-align: left;\n    padding-left: 20px;\n    color: var(--default-icon-color);\n}\n\n.appinfocontentvalue\n{\n    color:white;\n    text-align: right;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
